export function createInitialSubscription() {
  return {
    id: "",
    estalyId: "",
    uniqueToken: "",
    subscriptionLink: "",
    offers: [],
    discount: "",
    advisoryAgreement: "",
    informationNoticeLink: "",
    productInformationSheetLink: "",
    product: {
      title: "",
      price: "",
      referenceId: "",
      productNature: null,
      transactionDate: "",
      lineHolderName: "",
    },
    category: null,
    customer: {
      email: "",
      phone: "",
      firstName: "",
      lastName: "",
      birthDate: "",
      birthCity: "",
      birthCountry: "",
      nationality: "",
      professionalCustomer: false,
      sirenNumber: "",
      legalForm: "",
      buyerRole: "",
      companyName: "",
    },
    address: {
      address1: "",
      address2: "",
      city: "",
      province: "",
      country: "",
      zipCode: "",
      addressError: false,
    },
    invitationSentByEstaly: true,
    paymentInStorePlatform: false,
    sellerId: "",
    advisoryAnswer: {
      wantsInsurance: null,
      usageType: null,
      risks: [],
      offerType: null,
      hasExistingInsurance: undefined,
      existingInsuranceReason: null,
      existingInsuranceReasonOtherText: "",
      electronicDevicesValue: null,
      recommendedOffer: null,
      recommendedOfferId: null,
      deviceBoughtFromDistributor: true,
    },
  };
}

export function createInitialAcknowledgements() {
  return {
    advisoryAgreementViewed: false,
    informationNoticeViewed: false,
    productInformationSheetViewed: false,
    insuranceConsent: false,
    digitalDeliveryConsent: false,
  };
}
